import styled from 'styled-components';
import DataTable from '@components/DataTable';
import { Roles } from '@/pages/CompanyReport/components/InsiderTradingTransactions';

interface PercentSharesChanged {
  percentSharesChanged: number;
}

export const ShareholdersDataTable = styled(DataTable)`
  td {
    position: relative;
  }
`;

export const LoudText = styled('span')`
  color: ${({ theme }) => theme.color.brand01};
`;

export const Owner = styled('section')`
  ${({ theme }) => theme.typography.xSmallStrong}
`;

export const RoleIcons = styled(Roles)`
  padding-left: ${({ theme }) => theme.x1spacePx / 2}px;
`;

export const SecondaryText = styled('span')`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  > svg {
    fill: ${({ theme }) => theme.color.whiteRGBA(0.3)};
    position: absolute;
    right: ${({ theme }) => theme.x1spacePx}px;
    top: ${({ theme }) => theme.x8space}px;
  }
`;

export const LighterText = styled('span')`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;

export const NoDataText = styled.span`
  color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
`;

export const ChangeText = styled('span')<PercentSharesChanged>`
  ${({ percentSharesChanged, theme }) => {
    if (percentSharesChanged > 0) {
      return `color: ${theme.color.good}`;
    } else if (percentSharesChanged < 0) {
      return `color: ${theme.color.bad}`;
    }
    return `color: ${theme.color.whiteRGBA(0.5)}`;
  }}
`;

export const TooltipTerm = styled('span')`
  white-space: nowrap;
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: help;
  display: inline-block;
  background-color: ${({ theme }) => theme.color.brand01RGBA(0.1)};
`;

export const TooltipTitle = styled('p')`
  margin: 0;
  max-width: 200px;
  color: ${({ theme }) => theme.color.white};
  ${({ theme }) => theme.typography.tiny};
`;

export const ReportedDateTooltip = styled(TooltipTitle)`
  text-align: center;
`;
